import { useGetClientGroup } from './useGetClientGroup';
import { useGetOffer } from './useGetOffer';

export const useOfferBuyer = (interactionId?: string, skip?: boolean) => {
  const {
    offer,
    isLoading: isLoadingOffer,
    error: offerError,
  } = useGetOffer(interactionId ?? null, skip);

  const {
    clientGroup: buyer,
    isLoading: isLoadingBuyer,
    error: buyerError,
  } = useGetClientGroup(offer?.clientGroupId ?? null, skip);

  return {
    data: buyer,
    offer,
    isLoading: isLoadingOffer || isLoadingBuyer,
    error: offerError ?? buyerError,
  };
};
